// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"82d71fb9","78":"cc272126","344":"d877baba","388":"4e88273f","525":"7384aadd","686":"3c851760","719":"078cb225","735":"98e2b4f4","757":"99bd83f2","883":"e6e300f0","963":"e845b444"}[chunkId] + ".chunk.js";
};